import { showAllQuery } from "../constants/showAllQuery";
import { getSearchCollectionConfig } from "../search";

const shouldOmitShowAllQuery = (collectionId: string): boolean =>
    !!getSearchCollectionConfig(collectionId).omitShowAllQuery;

export const normalizeIncomingQuery = (
    value: string | null | undefined,
    collectionId: string
): string => {
    const trimmed = value?.trim() ?? "";
    if (trimmed === showAllQuery || trimmed === "") {
        return shouldOmitShowAllQuery(collectionId) ? "" : showAllQuery;
    }
    return trimmed;
};

export const resolveQueryForRequest = (
    value: string,
    collectionId: string
): string | undefined => {
    const normalized = normalizeIncomingQuery(value, collectionId);
    if (shouldOmitShowAllQuery(collectionId)) {
        return normalized || undefined;
    }
    return normalized;
};
